"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const galleryItems = [{
  id: 1,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1689780/img/album_cover_hiphop_noir.png",
  alt: "Hip Hop Album Production"
}, {
  id: 2,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1689780/img/album_cover_soul_vibe.png",
  alt: "Soul and R&B Production"
}, {
  id: 3,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1689780/img/album_cover_electronic_pulse.png",
  alt: "Electronic Music Production"
}];
export default function TheFullCatalog() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll();
  const {
    ref: gridRef,
    isVisible: isGridVisible
  } = useRevealOnScroll();
  return <section data-section-id="258783" id="the-full-catalog" className="py-16 md:py-24 bg-background text-foreground">
      <div className="container mx-auto px-4">
        <div ref={headerRef} className={`max-w-3xl mx-auto text-center mb-16 transition-all duration-700 ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="text-5xl md:text-7xl font-bold font-default text-primary mb-6 tracking-tighter uppercase">
            The Full Catalog
          </h2>
          <p className="text-xl text-muted-foreground font-mono uppercase tracking-widest">
            A comprehensive archive of sonic architecture and rhythmic soul
            engineered for the modern era.
          </p>
        </div>

        <div ref={gridRef} className={`grid grid-cols-1 md:grid-cols-3 gap-8 transition-all duration-700 delay-200 ${isGridVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          {galleryItems.map((item, i) => <div key={item.id} data-index={i} className="group relative aspect-[1/1] overflow-hidden border border-border cursor-pointer bg-card shadow-md">
              <img src={item.src} data-wvc-srcset={`${item.src}-wvc-srcset`} data-wvc-sizes={`${item.src}-wvc-sizes`} alt={item.alt} className="w-full h-full object-cover transition-all duration-700 grayscale group-hover:grayscale-0 group-hover:scale-105" loading="lazy" />
              <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-500 backdrop-blur-sm bg-background/40">
                <span className="font-mono text-[14px] font-bold uppercase tracking-widest text-primary-foreground bg-primary px-6 py-3 border border-primary shadow-lg">
                  View Project
                </span>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}